module.exports = __webpack_public_path__ + "img/10.6a9bbd51.png";